'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _feiseanna = require('../../../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _schools = require('../../../../../schools');

var _schools2 = _interopRequireDefault(_schools);

var _reportsPdf = require('../../../../../reports-pdf');

var _reportsPdf2 = _interopRequireDefault(_reportsPdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SchoolsController = function () {
  function SchoolsController($state, $filter, feis, fFeisService, msgService, fPDFReportsService) {
    var _this = this;

    _classCallCheck(this, SchoolsController);

    this.feis = feis;
    this._ = { $state: $state, $filter: $filter, fFeisService: fFeisService, fPDFReportsService: fPDFReportsService };

    this.getSchools().then(function (response) {
      _this.orderBy = 'name';
      _this.schools = response.map(function (x) {
        if (!x.paid) x.paid = 0;
        if (!x.registered) x.registered = 0;
        x.unpaid = x.registered - x.paid;
        return x;
      });
      _this.totals = _this.getTotal(_this.schools);
    }, function (err) {
      return msgService.displayErrorMsg(err);
    });
  }

  _createClass(SchoolsController, [{
    key: 'generateReportsPDF',
    value: function generateReportsPDF() {
      this.rows = [{
        name: 'School',
        propertyName: 'name',
        width: .7,
        align: 'left'
      }, {
        name: 'Paid',
        propertyName: 'paid',
        width: .1
      }, {
        name: 'Unpaid',
        propertyName: 'unpaid',
        width: .1
      }, {
        name: 'Total',
        propertyName: 'registered',
        width: .1
      }];
      this._.fPDFReportsService.convertToPDF(this.schools, this.rows, 'Competitor Counts By School', 'competitor-stats');
    }
  }, {
    key: 'getSchools',
    value: function getSchools() {
      return this._.fFeisService.schools(this.feis.id);
    }
  }, {
    key: 'getTotal',
    value: function getTotal(data) {
      var unpaid = data.map(function (el) {
        return el.unpaid || 0;
      }).reduce(function (prev, curr) {
        return prev + curr;
      }),
          paid = data.map(function (el) {
        return el.paid || 0;
      }).reduce(function (prev, curr) {
        return prev + curr;
      });

      return {
        unpaid: unpaid,
        paid: paid,
        total: unpaid + paid
      };
    }
  }, {
    key: 'go',
    value: function go(route, params) {
      this._.$state.go(route, { sid: params.id });
    }
  }, {
    key: 'order',
    value: function order(name) {
      if (this.orderBy === name) {
        this.orderReverse = !this.orderReverse;
      } else {
        this.orderReverse = false;
        this.orderBy = name;
      }
    }
  }, {
    key: 'update',
    value: function update(filter) {
      var data = this._.$filter('filter')(this.schools, filter);

      this.totals = this.getTotal(data);
    }
  }]);

  return SchoolsController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.schools', ['ui.router', 'ifeis.feiseanna', 'ifeis.pdf', 'ifeis.router-history', 'ifeis.schools']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.schools', {
    abstract: true,
    template: require('./tpl.html'),
    url: '/schools'
  }).state('feiseanna.one.admin.schools.all', {
    controller: SchoolsController,
    controllerAs: 'school',
    template: require('./schools/tpl.html'),
    url: '',
    ncyBreadcrumb: {
      label: 'Schools',
      parent: 'feiseanna.one.admin.manager'
    }
  });
}).controller('SchoolCompetitorController', SchoolsController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/schools/index.js
// module id = 569
// module chunks = 0